import { defineMessages } from 'react-intl';

export const messages: {
	controlKey: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	googleCalendarLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	controlKey: {
		id: 'dynamic-cards-search-page.icons.control-key',
		defaultMessage: 'Ctrl',
		description:
			'Accessibility label and display text for the Control keyboard key icon shown in keyboard shortcut hints on the dynamic cards search page.',
	},
	googleCalendarLabel: {
		id: 'dynamic-cards-search-page.icons.google-calendar-label',
		defaultMessage: 'Google Calendar',
		description: 'Accessibility label for the Google Calendar icon',
	},
});
